import React, { memo } from 'react'
import { OutlinedField } from '../Forms'

const DescriptionField = memo(({ classes, handleChange, value }) => {
  return (
    <OutlinedField
      label="Description"
      className={classes.textField}
      value={value}
      onChange={handleChange('description')}
      required
    />
  )
})

export default DescriptionField
